import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MbDualListBoxComponent } from './mb-dual-list-box/mb-dual-list-box.component';
import { MbFormFieldComponent } from './mb-form-field/mb-form-field.component';
import { MbRadioFieldComponent } from './mb-radio-field/mb-radio-field.component';
import { FilterPipe } from './filter-pipe/filter.pipe';
import { MbTurboSelectComponent } from './mb-turbo-select/mb-turbo-select.component';
import { MbTurboInputComponent } from './mb-turbo-input/mb-turbo-input.component';
import { FormsModule } from '@angular/forms';
import { MbCheckboxFieldComponent } from './mb-checkbox-field/mb-checkbox-field.component';
import { MbValidationDirective } from './directives/mb-validation.directive';
import { MbProgressBarComponent } from './mb-progress-bar/mb-progress-bar.component';
import { DecimalsPipe } from './decimals-pipe/decimals.pipe';

@NgModule({
  declarations: [
    MbFormFieldComponent,
    MbTurboSelectComponent,
    MbRadioFieldComponent,
    MbDualListBoxComponent,
    MbTurboInputComponent,
    MbCheckboxFieldComponent,
    FilterPipe,
    MbValidationDirective,
    MbProgressBarComponent,
    DecimalsPipe
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    MbFormFieldComponent,
    MbTurboSelectComponent,
    MbRadioFieldComponent,
    MbDualListBoxComponent,
    MbTurboInputComponent,
    MbCheckboxFieldComponent,
    MbValidationDirective,
    MbProgressBarComponent
  ]
})
export class MbComponentsModule { }
